module.exports = __webpack_public_path__ + "static/media/p7.37eb58f4.png";